import * as angular from 'angular';
import {ConfigScope} from "./config.base";
import template from './kepwareCounterConfig.tpl.html';

interface KepwareCounterConfigScope extends ConfigScope {
  isRequired: boolean;
}

export default angular.module('aps.controller.kepwareCounterConfig', [])
  .directive('apsKepwareCounterConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template,
      link: (scope: KepwareCounterConfigScope) => {
        let updateFormValidation = () => {
          scope.isRequired = scope.vm.instance.type === 21 || scope.vm.instance.type === 22 ? false : true; 
        }
        scope.$watch('vm.instance.type', updateFormValidation);
      },
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/kepwareCounterConfig.directive.ts